import React from 'react';
import { DateCalendar } from '@mui/x-date-pickers/DateCalendar';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';

const baseCalendarSx = {
  bgcolor: 'background.paper',
  borderRadius: '16px',
  p: 1,
  '& .MuiPickersCalendarHeader-root': {
    px: 0.5,
    mb: 0.75,
  },
  '& .MuiPickersCalendarHeader-label': {
    fontWeight: 800,
  },
  '& .MuiPickersDay-root': {
    borderRadius: '9999px',
    fontWeight: 600,
  },
  '& .MuiPickersDay-root:focus': {
    outline: 'none',
  },
  '& .MuiPickersDay-today': {
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: 'primary.main',
  },
  '& .MuiPickersDay-root.Mui-selected': {
    bgcolor: 'primary.main',
    color: 'primary.contrastText',
    '&:hover': {
      bgcolor: 'primary.dark',
    },
  },
  '& .MuiPickersDay-root.Mui-selected:hover': {
    bgcolor: 'primary.dark',
  },
  '& .MuiDayCalendar-weekDayLabel': {
    fontWeight: 700,
    color: 'text.secondary',
  },
};

const SharedDateCalendar = ({
  value,
  onChange,
  maxDate,
  minDate,
  allowFuture = false,
  disableFuture = true,
  disablePast = false,
  slots,
  slotProps,
  sx,
  ...rest
}) => {
  const resolvedDisableFuture = allowFuture ? false : disableFuture;
  const resolvedMaxDate = maxDate || (resolvedDisableFuture ? new Date() : undefined);

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <DateCalendar
        value={value}
        onChange={onChange}
        maxDate={resolvedMaxDate}
        minDate={minDate}
        disableFuture={resolvedDisableFuture}
        disablePast={disablePast}
        slots={slots}
        slotProps={slotProps}
        sx={[baseCalendarSx, ...(Array.isArray(sx) ? sx : sx ? [sx] : [])]}
        {...rest}
      />
    </LocalizationProvider>
  );
};

export default SharedDateCalendar;
